import { render } from "./taskWaitingProcess.vue?vue&type=template&id=5dcdf21c"
import script from "./taskWaitingProcess.vue?vue&type=script&lang=js"
export * from "./taskWaitingProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__